// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"29d57bf5557b9d16043b","655":"d2941fc9c6a49db447af"}[chunkId] + ".js";
};